import * as React from "react";
const SvgEmailBordered = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M11.75 4.625 9.403 6.5c-.773.615-2.04.615-2.813 0L4.25 4.625m7.5 8.625h-7.5C2 13.25.5 12.125.5 9.5V4.25C.5 1.625 2 .5 4.25.5h7.5C14 .5 15.5 1.625 15.5 4.25V9.5c0 2.625-1.5 3.75-3.75 3.75"
    />
  </svg>
);
export default SvgEmailBordered;
